import { render, staticRenderFns } from "./set01.vue?vue&type=template&id=5b89fcca&scoped=true&"
import script from "./set01.vue?vue&type=script&lang=js&"
export * from "./set01.vue?vue&type=script&lang=js&"
import style0 from "./set01.vue?vue&type=style&index=0&id=5b89fcca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b89fcca",
  null
  
)

export default component.exports